import { Link } from "react-router-dom";
import { siteUrl } from "../lib/siteUrl";

/**
 * Breadcrumb component with JSON-LD BreadcrumbList schema baked in by Seo on each page.
 * Pass `items` as [{ name, to? }] – last item is current page (no link).
 */
export default function Breadcrumbs({ items = [] }) {
    return (
        <nav aria-label="Fil d'Ariane" className="text-xs text-[var(--ink-soft)]" data-testid="breadcrumbs">
            <ol className="flex flex-wrap items-center gap-1.5">
                {items.map((it, i) => {
                    const isLast = i === items.length - 1;
                    return (
                        <li key={`crumb-${it.name}`} className="flex items-center gap-1.5">
                            {it.to && !isLast ? (
                                <Link to={it.to} className="hover:text-[var(--navy)] underline-offset-2 hover:underline">{it.name}</Link>
                            ) : (
                                <span className="text-[var(--navy)] font-medium">{it.name}</span>
                            )}
                            {!isLast && <i className="fa-solid fa-angle-right text-[10px] opacity-60" />}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}

export function breadcrumbJsonLd(items) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((it, idx) => ({
            "@type": "ListItem",
            position: idx + 1,
            name: it.name,
            ...(it.to ? { item: siteUrl(it.to) } : {}),
        })),
    };
}
